import type { ProductListingPage } from "@decocms/apps-commerce/types"
import { BrandSort } from "~/components/brandCustomPage/products/BrandSort"
import Pagination from "~/components/ui/Pagination"
// import FiltersDrawer from 'site/islands/Search/FiltersDrawer.tsx'

export interface BrandPaginationProps {
  page: ProductListingPage
  url: string
  isMobile?: boolean
}

export const BrandPaginationTop = ({ page, url, isMobile }: BrandPaginationProps) => {
  const pageInfo = page.pageInfo
  // const filters = page.filters
  // const categoryName = page.breadcrumb?.itemListElement.at(-1)?.name ?? ''

  return (
    <div className=''>
      {!!isMobile && (
        <p className='text-xs text-[#333333]'>
          Encontramos <span className='text-red-wine font-bold'>{pageInfo.records} produtos</span>
        </p>
      )}

      {
        /* {!!isMobile && (
        <div className=''>
          {filters?.length > 0 && (
            <FiltersDrawer
              filters={filters}
              categoryName={categoryName}
              isSearchPage={false}
              url={url}
              isMobile={isMobile}
              isPerformanceTestPage={false}
              paginateFilterOnMobile={true}
            />
          )}

          <BrandSort page={page} url={url} isMobile={isMobile} />
        </div>
      )} */
      }

      {!!isMobile && <BrandSort page={page} url={url} isMobile={isMobile} />}

      <div className='bg-neutral-200 rounded px-4 h-[47px] flex items-center justify-center md:justify-between'>
        {!isMobile && (
          <p className='text-sm text-[#333333]'>
            Encontramos <span className='text-red-wine font-bold'>{pageInfo.records} produtos</span>
          </p>
        )}

        <Pagination url={url} pageInfo={pageInfo} />

        {!isMobile && <BrandSort page={page} url={url} />}
      </div>
    </div>
  )
}
